import React from 'react'
import {StaticImage} from 'gatsby-plugin-image'
import {Row, Col} from 'react-bootstrap'
import Section from '../../components/Section'

import {list} from './ContactGP.module.scss'

const ContactGP: React.FC = () => (
  <Section id="contact-gp">
    <Row className="align-items-center g-5">
      <Col lg={6}>
        <h2 className="fs-1 fw-bold mb-4">
          When to contact
          <br />
          your GP?
        </h2>
        <p>
          Chickenpox is usually mild and clears up in about a week. However,
          some people can become seriously ill and need to see a doctor.
        </p>
        <p className="mb-0">Contact your GP if:</p>
        <ul className={list}>
          {contactGP.map((text) => (
            <li key={text} className="py-1">
              {text}
            </li>
          ))}
        </ul>
        <p className="mb-0">Contact your NHS 111 if:</p>
        <ul className={list}>
          {contactNHS.map((text) => (
            <li key={text} className="py-1">
              {text}
            </li>
          ))}
        </ul>
        <p>
          You should also get advice if you are originally from a country near
          the equator and have been exposed to chickenpox, as you may need
          treatment to stop you becoming seriously ill.
        </p>
      </Col>
      <Col lg={6}>
        <StaticImage
          src="./images/doctors.png"
          alt="Stock image of Healthcare Professionals"
          width={650}
        />
      </Col>
    </Row>
  </Section>
)

export default ContactGP

const contactGP = [
  'You’re not sure if it’s chickenpox',
  'You’re concerned about your child',
]

const contactNHS = [
  'The skin around the chickenpox blisters is hot, painful and red, but redness may be harder to see on brown or black skin',
  'Your child has chickenpox and is dehydrated',
  'Chickenpox symptoms suddenly get worse',
  'You’re pregnant and have not had chickenpox before, or you’re not sure, and you’ve been near someone with chickenpox',
  'You have a weakened immune system and have been near someone with chickenpox',
  'You think your newborn baby has chickenp',
]
